module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "Chapter1"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "pg_17_1",
      "src": "images/pg_17_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("On the eve of war this was the face of Mussolini’s medium tank force but it was hardly comparable to Hitler’s Panzer Mk III and IV. The Fiat-Ansaldo M11/39 medium tank was little more than an up-gunned light tank. While its 37mm gun was quite respectable for the late 1930s, the size of the turret meant that the main gun was placed in the hull, greatly limiting its traverse. Like many tanks of the day it suffered from poor mechanical reliability and its 30mm armour could not withstand the British 2-pounder anti-tank gun. Against the British Mk VI light tank, which was armed with just a machine-gun, the M11/39 was quite effective. However, against the British A series Cruiser and Matilda tanks it was completely outclassed and the crews quite often abandoned the M11/39 in the face of attack. To make matters worse for the Italians, only a hundred were ever produced. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s Collection")]), _vm._v(")")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5df99712","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_06_Chapter1.vue
// module id = 93
// module chunks = 0